import 'toastr/build/toastr.min.css'
import './tosatr.scss'
import toastr from 'toastr/build/toastr.min.js'
import Vue from 'vue'
import Plugin from './plugin'

Vue.use(Plugin, toastr)



// WEBPACK FOOTER //
// ./src/configs/toastr/index.js